module.exports = __webpack_public_path__ + "img/slider-2.ad22db74.svg";